var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-tab__content"},[_c('ConyForSelect',{model:{value:(_vm.copyForItemList),callback:function ($$v) {_vm.copyForItemList=$$v},expression:"copyForItemList"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }